<template>
    <u-card-outlined-tile v-bind="$attrs">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-card-outlined-tile>
</template>

<script>
import UCardOutlinedTile from "@/components/publish/styles/cards/u-card-outlined-tile.vue";

export default {
    props: {},
    components: {
        UCardOutlinedTile,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
